class CartPromotionWidget extends HTMLElement {
  constructor() {
    super();
  }

  static get selectors() {
    return {
      progressBar: "progress-bar",
      savings: "[data-savings]"
    }
  }

  static get attributes() {
    return {
      totalPrice: "total-price",
      thresholds: "thresholds",
      savings: "data-savings"
    }
  }

  static get modifiers() {
    return {
      value: {
        current: "cart-promotion-widget__value--current"
      }
    }
  }

  static get observedAttributes() {
    return [
      this.attributes.totalPrice
    ];
  }

  get thresholds() {
    try {
      return JSON.parse(this.getAttribute(CartPromotionWidget.attributes.thresholds));
    } catch (error) {
      return [];
    }
  }

  get totalPrice() {
    return parseInt(this.getAttribute(CartPromotionWidget.attributes.totalPrice));
  }

  set totalPrice(value) {
    this.setAttribute(CartPromotionWidget.attributes.totalPrice, value);
  }

  async connectedCallback() {
    document.addEventListener("theme:cart:change", this.onCartChange.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("theme:cart:change", this.onCartChange.bind(this));
  }

  calculateSavings() {
    const totalPrice = this.totalPrice;

    let currentSavings = 0;

    for (const threshold of this.thresholds) {
      if (totalPrice >= parseInt(threshold.value)) {
        currentSavings = threshold.savings;
      }
    }

    const savingsElements = [...this.querySelectorAll(CartPromotionWidget.selectors.savings)];

    savingsElements.forEach((savingsElement) => {
      savingsElement.classList.remove(CartPromotionWidget.modifiers.value.current);

      if (parseInt(savingsElement.getAttribute(CartPromotionWidget.attributes.savings)) === currentSavings) {
        savingsElement.classList.add(CartPromotionWidget.modifiers.value.current);
      }
    });
  }

  async onCartChange(event) {
    const items = event?.detail?.cart?.items;

    if (!items?.length) {
      this.totalPrice = 0;
      return;
    }

    this.totalPrice = items
      .filter((item) => !item.gift_card)
      .reduce((sum, item) => sum + item.final_line_price, 0);
  }

  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");

    const progressBarElement = this.querySelector(CartPromotionWidget.selectors.progressBar);

    if (!progressBarElement) {
      return;
    }

    switch (attribute) {
      case CartPromotionWidget.attributes.totalPrice:
        progressBarElement.valueNow = newValue;
        break;
    }

    this.calculateSavings();
  }
}

if (!customElements.get("cart-promotion-widget")) {
  customElements.define("cart-promotion-widget", CartPromotionWidget);
}
